
export default {
  name: 'AppMultiTabDropdown',
  props: {
    selectedOptions: { type: Object, default: null },
    label: { type: String, required: true },
    options: { type: Array, required: true },
    menuAlign: {
      type: String,
      default: 'left',
      validator: v => ['left', 'right', 'center', 'auto'].includes(v)
    },
    description: { type: String, default: null }
  },
  data() {
    return {
      isDropdownMenuVisible: false
    };
  },
  computed: {
    isSelected() {
      const selectedOptionEntries = Object.entries(this.selectedOptions).filter(
        ([_, values]) => values.length
      );
      return selectedOptionEntries.length > 0;
    },
    selectedOptionLabel() {
      if (!this.isSelected) return this.label;

      return Object.entries(this.selectedOptions)
        .map(([optionId, selectedValue]) => {
          const option = this.options.find(o => o.id === parseInt(optionId));

          if (!option) return null;

          return option.product_option_values
            .filter(pov => selectedValue.includes(pov.value))
            .map(pov => pov.name)
            .join(', ');
        })
        .filter(Boolean)
        .join(', ');
    }
  },
  methods: {
    click(e) {
      if (!e.target.closest('.AppMultiTabDropdown__modeless')) {
        this.isDropdownMenuVisible ? this.close() : this.open();
      }
    },
    open() {
      this.isDropdownMenuVisible = true;
    },
    close() {
      this.isDropdownMenuVisible = false;
    }
  }
};
